import { render, staticRenderFns } from "./the-overlay.vue?vue&type=template&id=b9333f08&scoped=true&"
import script from "./the-overlay.vue?vue&type=script&lang=js&"
export * from "./the-overlay.vue?vue&type=script&lang=js&"
import style0 from "./the-overlay.vue?vue&type=style&index=0&id=b9333f08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9333f08",
  null
  
)

export default component.exports